/* eslint-disable */
import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Row } from 'react-bootstrap';
import TeamSubmissionForm from './submission-form';
import { history } from '../../../store';
import { getSubmissionMeta, createSubmission } from '../../../actions/submissions';
import { loadPageContent } from '../../../actions/content';
import InlineCKEditor from '../../common/editor/inline-editor/index';
import {toast} from "react-toastify";
import ToastMessage from "../../common/toast-message";
import {isAbmPseudoLoggedIn, isRdrPseudoLoggedIn} from "../../../utils/tokenUtils";

const model = 'deep.submission';

class TeamSubmissionFormPage extends Component {
  handleContentSaved = () => {
    const { dispatch } = this.props;

    dispatch(loadPageContent('api/pages/submission'));
  };

  UNSAFE_componentWillMount() {
    if(isAbmPseudoLoggedIn() || isRdrPseudoLoggedIn()){
      toast.error(<ToastMessage iconStyle="error" message="You don't have permission to view this page"/>);
      history.push('/');
    }

    const { dispatch } = this.props;

    dispatch(loadPageContent('api/pages/submission'));
    dispatch(getSubmissionMeta());
  }

  handleSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, createSubmission(payload, dispatch)))
      .then(() => { this.props.dispatch(actions.reset('deep.submission')) });
  };

  render() {
    const { loading, contents, meta, isNgp } = this.props;

    return (
      <div className="container-fluid">
        {loading && 'Loading...'}
        <Row>
          <Col md={12}>
            <InlineCKEditor
              contents={contents['submission_submission_text']}
              identifier={'submission_submission_text'}
              onContentSaved={this.handleContentSaved}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="padding-flush">
            <TeamSubmissionForm
              onSubmit={this.handleSubmit.bind(this)}
              model={model}
              meta={meta}
              isNgp={isNgp}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  submission: state.submissions.submission,
  loading: !state.submissions.fetched && state.submissions.fetching,
  meta: state.submissions.meta,
  contents: state.content.list
});

export default connect(mapStateToProps)(TeamSubmissionFormPage);
